import { render, staticRenderFns } from "./PaDeptAdd.vue?vue&type=template&id=7120f3ee&scoped=true"
import script from "./PaDeptAdd.vue?vue&type=script&lang=js"
export * from "./PaDeptAdd.vue?vue&type=script&lang=js"
import style0 from "./PaDeptAdd.vue?vue&type=style&index=0&id=7120f3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120f3ee",
  null
  
)

export default component.exports